import type { Session } from '@supabase/supabase-js';
import { createBrowserClient } from '@supabase/ssr';
import { defineNuxtPlugin } from '#imports';
import type { Database } from '~~/types/Supabase';
import { useSupabaseUser } from '~/composables/useSupabaseUser';
import { useSupabaseSession } from '~/composables/useSupabaseSession';

export default defineNuxtPlugin({
	name: 'supabase',
	enforce: 'pre',
	setup: () => {
		const { public: { supabase: { url, key } } } = useRuntimeConfig();

		const client = createBrowserClient<Database>(url, key);

		const currentUser = useSupabaseUser();
		const currentSession = useSupabaseSession();

		client.auth.onAuthStateChange((_, session: Session | null) => {
			if (JSON.stringify(currentSession.value) !== JSON.stringify(session)) {
				currentSession.value = session;
				if (session?.user) {
					client.auth.getClaims().then(({ data }) => {
						currentUser.value = data?.claims ?? null;
					});
				} else {
					currentUser.value = null;
				}
			}
		});

		return {
			provide: {
				supabase: client,
			},
		};
	},
});
